import type { RouteObject } from "react-router-dom";
import Layout from "@/components/feature/Layout";
import NotFound from "@/pages/NotFound";
import Home from "@/pages/home/page";
import CategoryPage from "@/pages/category/page";
import DetailPage from "@/pages/detail/page";
import PlayPage from "@/pages/play/page";
import SearchPage from "@/pages/search/page";
import NewsListPage from "@/pages/news/list/page";
import NewsDetailPage from "@/pages/news/detail/page";
import AboutPage from "@/pages/about/page";
import FavoritesPage from "@/pages/favorites/page";
import HistoryPage from "@/pages/history/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category", element: <CategoryPage /> },
      { path: "category/:type", element: <CategoryPage /> },
      { path: "detail/:id", element: <DetailPage /> },
      { path: "play/:id", element: <PlayPage /> },
      { path: "search", element: <SearchPage /> },
      { path: "news", element: <NewsListPage /> },
      { path: "news/:id", element: <NewsDetailPage /> },
      { path: "about", element: <AboutPage /> },
      { path: "favorites", element: <FavoritesPage /> },
      { path: "history", element: <HistoryPage /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;